import React from "react";

const Contact = ()=>{
    return(
        <div className="contact">
            <ul>
                <li>phone:+255711429059</li>
            </ul>
        </div>
    )
}

export default Contact;